import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/punto_venta/clientes';
import Cliente from './Clientes';

const ms2p = (state) => {
  return {
    ...state.clientes_pv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Cliente);
